module.exports = __webpack_public_path__ + "img/no_shop_placeholder.2e79aa7b.png";